import * as React from 'react';
import { Text } from '@audi/audi-ui-react-v2';
import { useI18n } from '@oneaudi/i18n-context';
export const Deviations = ({ productDeviations }) => {
    if (!productDeviations)
        return null;
    const headline = useI18n({
        defaultMessage: 'Product deviations (please maintain a text-key)',
        id: 'nemo.ui.sc.productdeviations.headline',
    });
    return (React.createElement("section", null,
        React.createElement(Text, { as: "h2", variant: "order3", spaceStackEnd: "l", spaceStackStart: "xxxl", "data-testid": "deviationsHeadline" }, headline),
        React.createElement(Text, { as: "p", variant: "copy1", spaceStackEnd: "xxxl" }, productDeviations)));
};
